export const ALLOWED_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg']
export const MAX_INCIDENT_IMAGES = 3
